module.exports = "<mat-spinner color=#123F6C></mat-spinner>\n\n"